export default "__VITE_ASSET__Bgr$W$wg__"